import moment from 'moment';
import 'moment/locale/zh-cn';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { computed, defineComponent, ref } from 'vue';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { useRoute, useRouter } from 'vue-router';
import { isLogin, SHOW_BRAND, getOtherLoginUrl
// clearOtherLoginUrl,
} from '@/utils';
export default defineComponent({
  setup: function () {
    var _a, _b;
    var userService = useService(UserService);
    var route = useRoute();
    var router = useRouter();
    var otherLoginUrl = getOtherLoginUrl();
    var loading = ref((_a = route.meta) === null || _a === void 0 ? void 0 : _a.auth);
    if (!((_b = route.meta) === null || _b === void 0 ? void 0 : _b.notInit)) {
      userService.init().then(function () {
        if (route.meta.auth && isLogin() === false) {
          if (otherLoginUrl) {
            window.location.replace(otherLoginUrl);
            // clearOtherLoginUrl();
            return;
          }
          var replaceUrl = SHOW_BRAND ? {
            name: 'Home'
          } : '/activity/list';
          if (route.meta.loginUrlName && typeof route.meta.loginUrlName === 'string') {
            replaceUrl = {
              name: route.meta.loginUrlName
            };
          }
          router.replace(replaceUrl);
          loading.value = false;
        } else {
          loading.value = false;
        }
      });
    }
    // 解决合肥投诉品牌事件 2024-03-21
    // if (SHOW_BRAND) {
    //   // 如果可以展示品牌信息，就修改title
    //   document.title = '核桃编程_世界机器人冠军带孩子学编程';
    // }
    var isNoMinWidth = computed(function () {
      var _a;
      return (_a = route.meta) === null || _a === void 0 ? void 0 : _a.noMinWidth;
    });
    return {
      locale: zhCN,
      moment: moment,
      loading: loading,
      isNoMinWidth: isNoMinWidth
    };
  }
});